import React, { memo, useEffect, useState } from "react";
import { Handle, Position } from "@xyflow/react";
import { MDBIcon, MDBLoadingManagement } from "mdb-react-ui-kit";
import { getAudioFile, getAudioFileForTTS, getAudioFileNew } from "../mediaplayers/AudioPlayer";
export default function AnnouncementNode ({ data, isConnectable }) {
  const [showLoader, setshowLoader] = useState(false);
  function onDelete(id) {
    data.onDelete(id);
  }

  const openGreeting = (e, code) => {
    e.stopPropagation();
    e.preventDefault();
    data.actionExecutor({
      action: 16,
      value: data.selected_object,
    });
    data.actionExecutor({
      action: 1,
      value: data.selected_object,
    });
  };

  const getAudio = async (id) =>{
    const audio = await getAudioFileNew(id, data.selected_object.greeting_type ?? 5 , data.selected_object.code, data.selected_object.filename);
    console.log(`###------------------------------------::${ JSON.stringify(data.selected_object)}`);
    console.log(audio);
    return audio;
  };
  const getTTSAudio = async (id) =>{
    const response = await getAudioFileForTTS(id, data.selected_object.greeting_type ?? 5 , data.selected_object.code, data.selected_object.filename);
    console.log(`###------------------------------------::${ JSON.stringify(data.selected_object)}`);
    console.log(response);
    return response;
  };

  async function streamResponseToPlayer(apiResponse, onDone) {
    try {
      const reader = apiResponse.body.getReader();
      const chunks = [];
      while (true) {
        const { done, value } = await reader.read();
        if (done) break;
        if (value) chunks.push(value);
      }
      if (onDone) onDone(chunks);
      // Detect actual format from magic bytes so the blob has the correct MIME type.
      // A wrong MIME type causes the browser to fire an error on preload="metadata",
      // which shows "--:--" for the duration until play is manually triggered.
      const hdr = chunks[0];
      let mimeType = 'audio/mpeg';
      if (hdr?.length >= 4) {
        if (hdr[0] === 0x1A && hdr[1] === 0x45 && hdr[2] === 0xDF && hdr[3] === 0xA3) {
          mimeType = 'audio/webm';
        } else if (hdr[0] === 0x4F && hdr[1] === 0x67 && hdr[2] === 0x67) {
          mimeType = 'audio/ogg';
        }
      }
      const blob = new Blob(chunks, { type: mimeType });
      data.selected_object.g_path = (URL.createObjectURL(blob));
    } catch (error) {
      console.log(`[AudioPlayer] streamResponseToPlayer: ${error}`);
    }
  }

  useEffect(() => {
    async function updateSelectedObject(data){
      if (data.selected_object) {
        if (data.selected_object.uploadType === 3) {
          setshowLoader(true);
           let response =  await getTTSAudio(data.id);
            data.greet_info = data.selected_object;
             if (response?.status === 200) {
              await streamResponseToPlayer(response, (chunks) => {
                 data.selected_object.g_wav_file  = (new Blob(chunks, { type: "audio/mpeg" }));
              });
            }
            setshowLoader(false);
        } else {
          setshowLoader(true);
          let response = await getAudio(data.id);
          if (response?.status === 200) {
              await streamResponseToPlayer(response);
            }
            setshowLoader(false);
         data.greet_info = null;
        }
        data.info = { pre_announce: { greeting_mode: 1 } };
      }
    }
    // Only run the effect if data.selected_object changes
    if (data.selected_object) {
      updateSelectedObject(data);
    }
  }, []); // Add dependencies to optimize when the effect runs

  const basicRef = useState(null);
  
  return (
    <>
      <div className="redNodeHeader">
        {data.label}
        <MDBIcon
          fas
          icon="times"
          className="cursor-pointer"
          color="light"
          onClick={() => onDelete(data.id)}
        ></MDBIcon>
      </div>
      <div className="nodeBody">
        <b>Greeting</b>

        <br />
        <div className="nodeAudioControls">
          {data.selected_object && (
            <>
              <audio
                src={data.selected_object.g_path + ""}
                controls
                controlsList="nodownload"
                className="audio-controls"
              ></audio>
            </>
          )}
        </div>
        <div className={showLoader ? " disable-routing" : ""}>
           <div className="d-flex align-items-center">
            {showLoader && (
             <div className="mini-spinner" ref={basicRef} style={{ zIndex: "1029" }}>
                <MDBLoadingManagement parentRef={basicRef} />
              </div>
            )}
        <div className="d-flex align-items-center justify-content-between ps-0 p-2" style={{wordBreak:'break-all', maxHeight:'80px', overflow:'auto'}}>
          <strong>
            {data.selected_object && (
              <>
                <div className="">
                  <p>{data.selected_object.display ? data.selected_object.display : data.selected_object.g_title? data.selected_object.g_title: "System Default"}</p>
                </div>
              </>
            )}
            {!data.selected_object && (
              <>
                <div className="">
                  <p style={{ color: "red" }}>No Recording Activated</p>
                </div>
              </>
            )}
          </strong>
          <br />
          <br />
        </div>
        </div>
        <small className="text-primary edit">
          <a href="#" onClick={(e) => openGreeting(e)} className="text-small">
            Add/Edit
          </a>
        </small>
        </div>
      </div>
      <Handle
        type="target"
        position={Position.Left}
        id="target"
        isConnectable={isConnectable}
      ></Handle>
    </>
  );
};
